// src/utils/setDayjsLocale.jsx
import dayjs from "dayjs";

// Tus archivos disponibles en /lang (según la captura)
const AVAILABLE_PICKERS = new Set([
  "cs",
  "de-AT",
  "de-CH",
  "de-DE",
  "en",
  "en-IE",
  "es",
  "fr-BE",
  "fr-CH",
  "fr-FR",
  "fr-LU",
  "it-CH",
  "it-IT",
  "nl-BE",
  "nl-NL",
  "no",
  "pl",
  "pt",
  "ro",
  "se",
  "sk",
  "tr",
]);

// Dayjs locales (en dayjs/locale/*) suelen ser SOLO base
const DAYJS_BASE_SUPPORTED = new Set([
  "cs",
  "de",
  "en",
  "es",
  "fr",
  "it",
  "nl",
  "nb", // dayjs suele usar nb para noruego bokmål
  "pl",
  "pt",
  "ro",
  "sv", // sueco
  "sk",
  "tr",
]);

function normalizeLang(lang) {
  return String(lang || "en")
    .replace("_", "-")
    .trim()
    .toLowerCase();
}

function toRegionKey(norm) {
  // "de-at" -> "de-AT"
  const [l, r] = norm.split("-");
  if (!r) return l;
  return `${l}-${r.toUpperCase()}`;
}

function pickersKeyFor(norm) {
  const regionKey = toRegionKey(norm);     // ej: de-AT
  const base = norm.split("-")[0];         // ej: de

  if (AVAILABLE_PICKERS.has(regionKey)) return regionKey;
  if (AVAILABLE_PICKERS.has(base)) return base;

  // casos especiales de tu lista
  if (base === "no" && AVAILABLE_PICKERS.has("no")) return "no";
  if (base === "se" && AVAILABLE_PICKERS.has("se")) return "se"; // tu fichero se.json
  return "en";
}

function dayjsBaseFor(norm) {
  const base = norm.split("-")[0];

  // mapeos especiales
  if (base === "no") return "nb";  // noruego -> nb (dayjs)
  if (base === "se") return "sv";  // tu "se" (sueco) -> sv (dayjs)

  if (DAYJS_BASE_SUPPORTED.has(base)) return base;
  return "en";
}

/**
 * Devuelve:
 * - adapterLocale: para MUI AdapterDayjs (base de dayjs)
 * - pickersLocaleKey: para cargar tus json (lang/<key>.json)
 */
export async function setDayjsLocale(lang) {
  const norm = normalizeLang(lang);

  const adapterLocale = dayjsBaseFor(norm);
  const pickersLocaleKey = pickersKeyFor(norm);

  // Cargar locale de dayjs si no es en
  if (adapterLocale !== "en") {
    try {
      await import(
        /* webpackInclude: /(cs|de|es|fr|it|nl|nb|pl|pt|ro|sv|sk|tr)\.js$/ */
        `dayjs/locale/${adapterLocale}.js`
        );
    } catch (e) {
      // fallback seguro
      await import("dayjs/locale/en.js");
      dayjs.locale("en");
      return { adapterLocale: "en", pickersLocaleKey: "en" };
    }
  }

  dayjs.locale(adapterLocale);
  return { adapterLocale, pickersLocaleKey };
}
